import React from 'react';
import { BellRing, ExternalLink, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const LiveEmergencyForegroundAlert = () => {
  const navigate = useNavigate();
  const [alert, setAlert] = React.useState(null);

  React.useEffect(() => {
    let timer;
    const receive = (event) => {
      setAlert(event.detail || null);
      clearTimeout(timer);
      timer = setTimeout(() => setAlert(null), 30000);
    };
    window.addEventListener('mesp:live-emergency', receive);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('mesp:live-emergency', receive);
    };
  }, []);

  if (!alert) return null;
  return (
    <aside dir="rtl" role="alert" data-testid="live-emergency-foreground-alert"
      className="fixed left-3 right-3 top-3 z-[10050] mx-auto max-w-xl border border-red-300 bg-[#7F1D1D] p-4 text-white shadow-2xl sm:left-auto sm:right-5 sm:top-5 sm:w-[420px]">
      <div className="flex items-start gap-3">
        <BellRing className="mt-0.5 shrink-0 text-amber-300" />
        <div className="min-w-0 flex-1">
          <strong className="block text-sm" data-testid="live-emergency-foreground-title">{alert.title}</strong>
          <p className="mt-1 text-xs text-red-50" data-testid="live-emergency-foreground-body">{alert.body}</p>
          <button type="button" data-testid="live-emergency-foreground-open"
            onClick={() => { setAlert(null); navigate(alert.link || '/admin/classroom-monitor'); }}
            className="mt-3 inline-flex items-center gap-1 border border-amber-300/70 bg-amber-300 px-3 py-1.5 text-xs font-black text-[#0A1128] transition-colors hover:bg-amber-200">
            <ExternalLink size={13} /> فتح غرفة القيادة
          </button>
        </div>
        <button type="button" aria-label="إغلاق" data-testid="live-emergency-foreground-close"
          onClick={() => setAlert(null)}
          className="shrink-0 p-1 text-red-100 transition-colors hover:text-white">
          <X size={16} />
        </button>
      </div>
    </aside>
  );
};
